import { observable } from "mobx";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class VehicleRegisterVehicleIdentificationResponse {
  /**
   * Vehicle serial number - unique vehicle identifier in the vehicle register.
   */
  @observable
  externalVehicleIdent!: number;

  /**
   * VIN (vehicle identification number) - an internationally unique identifier for motor vehicles.
   */
  @observable
  vin?: string;
}
